import { createFileRoute } from '@tanstack/react-router';
import { StockWorkspace } from '@/features/inventory/StockWorkspace';
export const Route = createFileRoute('/_dashboard/dashboard/inventory/')({
  component: StockWorkspace,
});
